import api from '@/config/api';

/**
 * Generic GET helper that unwraps the axios response.
 */
export async function fetchOne<T>(
  url: string,
  params?: Record<string, unknown>,
): Promise<T> {
  const { data } = await api.get<T>(url, { params });
  return data;
}

export { api };
